export default "__VITE_ASSET__ySwr7Y68__"